<template>
<el-dialog width="96%" destroy-on-close :visible.sync="dialogFormVisible" :close-on-click-modal="true" @close="closeAction">
  <div style="display: flex;justify-content: center;flex-direction: column;align-items: center;width: 100%;">
    <el-transfer
        class="transfer-contain"
        filterable
        filter-placeholder="输入订单名称搜索"
        :titles="['全部订单', '提现订单']"
        v-model="value2"
        @change="handleChange"
        :data="data2">
      <div class="transfer-footer" slot="right-footer">提现总余额：{{total}}</div>

    </el-transfer>
    <div style="display: flex;width:100%;justify-content: flex-end;margin-top:16px;margin-right:16px;align-items:center;">
      <div style="margin-right: 16px;">提现日期</div>
      <el-date-picker type="date" placeholder="请选择提现日期" v-model="withdrawDate" format="yyyy-MM-dd" value-format="yyyy-MM-dd" style="width: 200px;"></el-date-picker>
    </div>
    <div style="display: flex;width:100%;justify-content: flex-end;margin-top:16px;margin-right:16px;">
      <el-button size="small" type="primary" @click="withdrawAction">提现</el-button>
    </div>
  </div>

</el-dialog>
</template>

<script>
import {handleBalanceWithdraw} from "@/api/api";

export default {
  name: "WithdrawSelection",
  props:['value','withDrawList'],
  watch:{
    value(newVal){
      this.dialogFormVisible = newVal
      if(this.dialogFormVisible){
        // console.log('dialogd打开，刷新')
      }
    },
    withDrawList: {
      immediate: true,
      handler: function (newVal) {
        this.data2 = newVal.map((a,i)=>({
          label:`${a.project_id}-${a.project_name}-${a.platform}  (余额：${a.amount})`,
          key: i,
          disabled: a.frozen ? true : false,
          amount: a.amount
        }))
      }
    }
  },
  data() {
    return {
      dialogFormVisible: false,
      data2: [],
      value2: [],
      withdrawDate:''
    }
  },
  computed:{
    total(){
      let total = this.value2.reduce((a,b)=>{
        let amount = this.withDrawList[b].amount
        return a + amount
      },0)
      return total.toFixed(2)
    }
  },
  methods:{
    handleChange(a){
      // console.log('change',this.value2,a)
    },
    closeAction(){
      this.value2 = []
      this.$emit('input',false)
    },
    async withdrawAction(){
      if(!this.value2.length){
        this.$message.warning("请选择提现订单")
        return
      }
      let action = await this.checkDoing('确定提现吗?','确定','取消',true)
      if(action){
        let data = this.value2.map(idx=>this.withDrawList[idx])
        let postData = {
          data,
          date: this.withdrawDate
        }
        // console.log('TODO:请求接口提现',postData)
        let res = await handleBalanceWithdraw(postData)
        // console.log('handleBalanceWithdraw/res',res)
        if(res.respCode=='000000'){
          this.$message.success('提现成功')
          this.$emit('updateTable')
          this.closeAction()
        }else{
          this.$message.error(res.respMsg)
        }
      }
    },
    async checkDoing(confirmMessage='审批同意吗？',confirmText='同意',cancelText='不同意',closeAsCancel=false){
      let title = "提示"
      return new Promise(resolve => {
        this.$alert('<div style="display: flex;flex-direction: column;justify-content: center;align-items: flex-start;">' +
            `<div style="color:black;">${confirmMessage}</div>`+
            '</div>', title, {
              dangerouslyUseHTMLString: true,
              customClass: 'return-visit-message-box-3',
              showCancelButton: true,
              distinguishCancelAndClose:true,
              confirmButtonText: confirmText,
              cancelButtonText: cancelText,
              callback: action => {
                if (action == 'confirm') {
                  // console.log(confirmText)
                  resolve(1)
                } else if(action == 'cancel') {
                  if(closeAsCancel){
                    // console.log('取消')
                    resolve(0)
                  }else{
                    // console.log(cancelText)
                    resolve(-1)
                  }
                } else {
                  // console.log('取消')
                  resolve(0)

                }
              }
            }
        )
      })


    },

  }

}
</script>

<style>
.transfer-contain{
  display: flex;
  justify-content: center;
  width: 100%;
}
.transfer-contain .el-input{
  width:calc(100% - 30px) !important
}
.transfer-contain .el-transfer-panel {
  width: calc(50% - 100px);
}
.transfer-footer{
  height: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-right: 16px;
  font-weight: bolder;
}
</style>
